export default __webpack_public_path__ + "static/media/IMG_5407.bad96e1a.PNG";